import classNames from '../../utils/classNames'

// Reusable brand loader mirroring the pre-React #app-shell splash in index.html
// (FUN88 logo + gold spinner). Uses the theme-aware `bg-primary` and existing
// Tailwind keyframes (`animate-pop` / `animate-rotate-1.5`) so no CSS/config is
// added. The logo is preloaded via a <link rel="preload" as="image"> in
// index.html so it paints instantly on first mount with no network flash.
//
// NOTE: the spinner deliberately uses `animate-rotate-1.5` (the project's custom
// `rotate` keyframe), NOT Tailwind's built-in `animate-spin`. bottom-nav.css
// defines a global `@keyframes spin` (the nav-icon effect: animates width +
// translate) and CSS keyframes are global, so `animate-spin` picks up the wrong
// keyframes and the spinner breaks. Keep it on `rotate`.
interface BrandLoadingProps {
  // Cover the whole viewport instead of just the content region. Use for the
  // app-boot Suspense fallback, where no header/bottom nav exists yet. Default
  // (content-region) suits in-app game/sports loading, keeping the header/nav
  // visible below the 60px header and above the mobile bottom nav.
  fullScreen?: boolean
  // Dim as a translucent overlay (the shared modal backdrop color) instead of
  // the opaque `bg-primary` splash, so the content underneath stays visible.
  // Use when layering the loader over an existing screen (e.g. a modal).
  overlay?: boolean
}

const BrandLoading = ({
  fullScreen = false,
  overlay = false,
}: BrandLoadingProps) => {
  return (
    <div
      className={classNames(
        'fixed left-0 flex w-screen flex-col items-center justify-center gap-[26px]',
        overlay ? 'bg-[rgba(32,38,50,0.7)]' : 'bg-primary-bg',
        fullScreen
          ? 'top-0 z-[600] h-screen'
          : 'top-[60px] z-10 h-[calc(100dvh-120px)] xl:h-[calc(100dvh-60px)]',
      )}>
      <div className="h-24 w-24 ">
        <img
          className="h-24 w-24 rounded-[22px] animate-pop shadow-[0_10px_30px_rgba(0,0,0,0.5),0_0_44px_rgba(212,175,55,0.28)]"
          width={96}
          height={96}
          alt="FUN88"
          src="/pwa-icon-180x180.webp"
        />
      </div>
      <div className="h-[38px] w-[38px]">
        <div className="relative w-full h-full rounded-full border-[3px] border-[rgba(212,175,55,0.18)] border-t-[#00a6ff] dark:border-t-[#d4af37] animate-rotate-1.5" />
      </div>
    </div>
  )
}

export default BrandLoading
